

import { Component, OnInit, ViewChild, HostBinding } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-q88',
  templateUrl: './q88.component.html',
  styleUrls: ['./q88.component.scss']
})
export class Q88Component implements OnInit {
  RetriveData: any[] = [];
  paginatedData: any[] = [];
  vesselImoList: any[] = [];
  itemsPerPage: number = 100;
  currentPage: number = 0;
  vesselName: string = '';
  isExpanded: boolean = false;
  filterForm!: FormGroup;
  filteredData: any[] = [];
  elements: any[] = [];
  selectedShips: any;
  clientName: any;
  tableHeaders: string[] = [];
  isFilterOpen = false;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  filterDropdown: any = {
    vesselName: false,
    imoNumber: false,
    segment: false,
    yard: false,
    yearBuilt: false,
    technicalOperator: false,
    commercialOperator: false,
    class: false
  };

  filterOptions: any = {};
  searchText: any = {};
  activeFilterColumns: any[] = [];
  selectedDynamicColumn = '';
  fieldSelections: {
    vesselName: string[];
    imoNumber: string[];
    segment: string[];
    yard: string[];
    yearBuilt: string[];
    technicalOperator: string[];
    commercialOperator: string[];
    class: string[];
  } = {
    vesselName: [],
    imoNumber: [],
    segment: [],
    yard: [],
    yearBuilt: [],
    technicalOperator: [],
    commercialOperator: [],
    class: [],
  };

  dataSource = new MatTableDataSource<any>([]);
  fromOnboardingForm = false;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private requestFormService: RequestFormService,
    private pRequestFormService: PortRequestFormServiceService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.fromOnboardingForm = !!(
      history.state as { fromOnboardingForm?: boolean }
    )?.fromOnboardingForm;
    this.filterForm = this.fb.group({
      vesselName: [this.fieldSelections.vesselName],
      imoNumber: [this.fieldSelections.imoNumber],
      segment: [this.fieldSelections.segment],
      yard: [this.fieldSelections.yard],
      yearBuilt: [this.fieldSelections.yearBuilt],
      technicalOperator: [this.fieldSelections.technicalOperator],
      commercialOperator: [this.fieldSelections.commercialOperator],
      class: [this.fieldSelections.class]
    });

    this.generateUniqueVesselImoList();
  }
  showFilterColumns() {
    const f = this.filterForm.value;

    const map: any = {
      yard: 'yard',
      yearBuilt: 'year_built',
      technicalOperator: 'technical_operator_name',
      commercialOperator: 'commercial_operator_name',
      class: 'class_notation'
    };

    this.activeFilterColumns = Object.keys(map).map(key => ({
      label: this.formatHeader(map[key]),
      key: map[key],
      count: f[key]?.length || 0,
      active: !!f[key]?.length
    }));
  }
  toTitleCase(value: any): string {
    if (!value) return '-';

    return String(value)
      .toLowerCase()
      .split(' ')
      .filter(Boolean)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  selectDynamicColumn(col: any) {
    this.selectedDynamicColumn = this.selectedDynamicColumn === col.key ? '' : col.key;
  }
  toggleSelection(field: string, value: any) {
    const control = this.filterForm.get(field);
    let arr = control?.value || [];

    if (arr.includes(value)) {
      arr = arr.filter((x: any) => x !== value);
    } else {
      arr.push(value);
    }

    control?.setValue(arr);
  }

  isChecked(field: string, value: any) {
    return this.filterForm.get(field)?.value.includes(value);
  }


  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  @HostBinding('class.pc-light') get pcLight(): boolean {
    return !this.isDarkMode();
  }
  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    console.log('sort connected', this.sort);
  }
downloadPdf(item: any) {
  if (!item?.download_endpoint) {
    this.toastr.error('PDF not available');
    return;
  }

  this.pRequestFormService.downloadQ88Pdf(item.download_endpoint)
    .subscribe({
      next: (res: any) => {
        if (res?.success && res?.download_url) {
          // same tab me open hoga
          window.location.href = res.download_url;
        } else {
          this.toastr.error('Download URL not found');
        }
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('PDF open failed');
      }
    });
}
selectAll(field: string) {
  const allOptions = this.getFilteredOptions(field);
  this.filterForm.get(field)?.setValue([...allOptions]);
}

clearField(field: string) {
  this.filterForm.get(field)?.setValue([]);
}

isAllSelected(field: string): boolean {
  const selected = this.filterForm.get(field)?.value || [];
  const options = this.getFilteredOptions(field);
  return options.length > 0 && selected.length === options.length;
}

toggleSelectAll(field: string, event: any) {
  if (event.target.checked) {
    this.selectAll(field);
  } else {
    this.clearField(field);
  }
}
  private parseNestedJson(data: any): any {
    if (!data || typeof data !== 'object') return data;

    // List of fields that are expected to be JSON strings
    const fieldsToParse = [
      'cargo_eductors',
      'cargo_manifold_connections',
      'cargo_pumps',
      'fuel_oil_capacity_cu_metres',
      'number_size_type_reducers',
      'number_size_type_vecs_reducers',
      'segregation_capacity_cu_metres',
      'stripping_pumps',
      'raw_vessel_data'
    ];

    const parsedData = { ...data };

    for (const field of fieldsToParse) {
      const value = parsedData[field];
      if (typeof value === 'string') {
        try {
          parsedData[field] = JSON.parse(value);
        } catch (e) {

          console.warn(`Could not parse JSON string for field: ${field}`, value);
        }
      }
    }


    if (this.isObject(parsedData['cargo_manifold_connections'])) {
      const details = parsedData['cargo_manifold_connections']['details'];
      if (typeof details === 'string') {
        try {
          parsedData['cargo_manifold_connections']['details'] = JSON.parse(details);
        } catch (e) { /* ignore */ }
      }
    }

    return parsedData;
  }

  generateUniqueVesselImoList() {
    this.pRequestFormService.getQ88VesselsData().subscribe({
      next: (response: any) => {
        const data = response?.data || [];

        // Sort data by extraction_timestamp desc to get newest on top
        data.sort((a: any, b: any) => new Date(b.extraction_timestamp).getTime() - new Date(a.extraction_timestamp).getTime());
        
        // Flag the newest entry (Serial Number 1)
        if (data.length > 0) {
          data[0].isNew = true;
        }

        this.elements = [...data];
        this.filteredData = [...data];
        this.RetriveData = [...data];
        this.vesselImoList = [...data];

        this.dataSource = new MatTableDataSource([...data]);

        const unique = (arr: any[], numeric = false) =>
          [...new Set(arr.filter(Boolean))]
            .sort((a, b) =>
              numeric
                ? Number(a) - Number(b)
                : String(a).localeCompare(String(b), undefined, { numeric: true })
            );

        this.filterOptions = {
          vesselName: unique(data.map((x: any) => x.vessel_name)),
          imoNumber: unique(data.map((x: any) => x.imo_number)),
          segment: unique(data.map((x: any) => x.segment)),
          yard: unique(data.map((x: any) => x.yard)),
          yearBuilt: unique(data.map((x: any) => x.year_built), true),
          technicalOperator: unique(data.map((x: any) => x.technical_operator_name)),
          commercialOperator: unique(data.map((x: any) => x.commercial_operator_name)),
          class: unique(data.map((x: any) => x.class_notation))
        };

        this.dataSource.sort = this.sort;

        if (data.length) {
          this.tableHeaders = Object.keys(data[0]);
        }
      }
    });
  }
  get tableData() {
    return this.dataSource.sort
      ? this.dataSource.sortData(
        [...this.dataSource.data],
        this.dataSource.sort
      )
      : this.dataSource.data;
  }
  getFilterOptions(field: string): string[] {
    return (this.filterOptions[field] || []).map((item: any) => String(item));
  }
  getFilteredOptions(field: string) {
    const search = (this.searchText[field] || '').toLowerCase();

    return (this.filterOptions[field] || []).filter((item: any) =>
      String(item || '')
        .toLowerCase()
        .includes(search)
    );
  }
filterClick() {
  const f = this.fieldSelections;
  this.filterForm.patchValue(f, { emitEvent: false });

  this.filteredData = this.elements.filter((item: any) =>
    (!f.vesselName?.length || f.vesselName.includes(String(item.vessel_name))) &&
    (!f.imoNumber?.length || f.imoNumber.includes(String(item.imo_number))) &&
    (!f.segment?.length || f.segment.includes(String(item.segment))) &&
    (!f.yard?.length || f.yard.includes(String(item.yard))) &&
    (!f.yearBuilt?.length || f.yearBuilt.includes(String(item.year_built))) &&
    (!f.technicalOperator?.length ||
      f.technicalOperator.includes(String(item.technical_operator_name))) &&
    (!f.commercialOperator?.length ||
      f.commercialOperator.includes(String(item.commercial_operator_name))) &&
    (!f.class?.length || f.class.includes(String(item.class_notation)))
  );

  // table update
  this.dataSource.data = [...this.filteredData];

  // old cascading dropdown logic keep
  const unique = (arr: any[], numeric = false) =>
    [...new Set(arr.filter(Boolean))].sort((a, b) =>
      numeric
        ? Number(a) - Number(b)
        : String(a).localeCompare(String(b), undefined, { numeric: true })
    );

  const d = this.filteredData.length ? this.filteredData : this.elements;

  this.filterOptions = {
    vesselName: unique(d.map((x: any) => x.vessel_name)),
    imoNumber: unique(d.map((x: any) => x.imo_number)),
    segment: unique(d.map((x: any) => x.segment)),
    yard: unique(d.map((x: any) => x.yard)),
    yearBuilt: unique(d.map((x: any) => x.year_built), true),
    technicalOperator: unique(d.map((x: any) => x.technical_operator_name)),
    commercialOperator: unique(d.map((x: any) => x.commercial_operator_name)),
    class: unique(d.map((x: any) => x.class_notation))
  };

  // keep already selected values valid
  (Object.keys(f) as Array<keyof typeof this.fieldSelections>).forEach((key) => {
    const validSelected = (f[key] || []).filter((val: any) =>
      this.getFilterOptions(key).includes(String(val)),
    );
    this.fieldSelections[key] = validSelected;
    this.filterForm.get(key)?.setValue(validSelected, { emitEvent: false });
  });

  this.currentPage = 0;
  this.showFilterColumns();
  this.isFilterOpen = false;
}
  toggleDropdown(field: string) {
    Object.keys(this.filterDropdown).forEach(key => {
      if (key !== field) {
        this.filterDropdown[key] = false;
      }
    });

    this.filterDropdown[field] = !this.filterDropdown[field];
  }

  getSelectedCount(field: string): number {
    return this.filterForm.get(field)?.value?.length || 0;
  }

  closeAllDropdowns() {
    Object.keys(this.filterDropdown).forEach(key => {
      this.filterDropdown[key] = false;
    });
  }
  clearClick() {
  const allData = [...this.elements];

  // reset form
  this.filterForm.reset({
    vesselName: [],
    imoNumber: [],
    segment: [],
    yard: [],
    yearBuilt: [],
    technicalOperator: [],
    commercialOperator: [],
    class: []
  });
  this.fieldSelections = {
    vesselName: [],
    imoNumber: [],
    segment: [],
    yard: [],
    yearBuilt: [],
    technicalOperator: [],
    commercialOperator: [],
    class: [],
  };

  // reset search text
  this.searchText = {
    vesselName: '',
    imoNumber: '',
    segment: '',
    yard: '',
    yearBuilt: '',
    technicalOperator: '',
    commercialOperator: '',
    class: ''
  };

  // close dropdowns
  this.closeAllDropdowns();

  // reset table
  this.filteredData = allData;
  this.dataSource.data = allData;

  // reset chips
  this.activeFilterColumns = [];
  this.selectedDynamicColumn = '';

  // IMPORTANT → reset dropdown options also
  const unique = (arr: any[], numeric = false) =>
    [...new Set(arr.filter(Boolean))]
      .sort((a, b) =>
        numeric
          ? Number(a) - Number(b)
          : String(a).localeCompare(String(b), undefined, { numeric: true })
      );

  this.filterOptions = {
    vesselName: unique(allData.map((x: any) => x.vessel_name)),
    imoNumber: unique(allData.map((x: any) => x.imo_number)),
    segment: unique(allData.map((x: any) => x.segment)),
    yard: unique(allData.map((x: any) => x.yard)),
    yearBuilt: unique(allData.map((x: any) => x.year_built), true),
    technicalOperator: unique(allData.map((x: any) => x.technical_operator_name)),
    commercialOperator: unique(allData.map((x: any) => x.commercial_operator_name)),
    class: unique(allData.map((x: any) => x.class_notation))
  };
}

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }


  filterByVesselAndImo(vessel: string, imo: string) {
    this.vesselName = vessel;
    this.pRequestFormService.getQ88VesselsDetailData(imo).subscribe({
      next: (response: any) => {
        console.log(` Details for ${vessel} (${imo}):`, response);


        const vesselDetails = response?.data || response;


        let rawDataArray = Array.isArray(vesselDetails) ? vesselDetails : [vesselDetails];


        this.paginatedData = rawDataArray.map(item => this.parseNestedJson(item));


        if (this.paginatedData.length > 0) {
          const apiKeys = Object.keys(this.paginatedData[0]).filter(
            key =>
              ![
                'raw_vessel_data',
                'id',
                'is_active',
                'created_at',
                'extraction_timestamp',
                'extraction_success_rate',
                'extraction_model'
              ].includes(key)
          );

          // PDF order priority
          const pdfOrder = [
            'date_updated',
            'vessel_name',
            'imo_number',
            'date_delivered',
            'builder',
            'type_of_vessel',
            'type_of_hull',
            'technical_operator',
            'commercial_operator',
            'classification_society',
            'class',
            'date_place_last_drydock',
            'date_next_drydock_due',
            'length_overall_loa',
            'length_between_perpendiculars_lbp',
            'extreme_breadth_beam',
            'moulded_depth',
            'net_tonnage',
            'gross_tonnage'
          ];

          // Existing keys in PDF order
          const orderedKeys = pdfOrder.filter(key => apiKeys.includes(key));

          // Remaining dynamic keys
          const remainingKeys = apiKeys.filter(key => !pdfOrder.includes(key));

          // Final headers
          this.tableHeaders = [...orderedKeys, ...remainingKeys];
        }
      },
      error: (err) => {
        console.error(' Error fetching vessel details:', err);
        this.toastr.error('Failed to fetch detailed vessel data');
      }
    });
  }

  resetFilter() {
    this.paginatedData = [];
  }



  formatHeader(key: string): string {
    if (!key) return '';
    return key
      .replace(/_/g, ' ') // replace underscores
      .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize words
  }


  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }


  isArrayOfObjects(value: any): boolean {

    return Array.isArray(value) && value.length > 0 && this.isObject(value[0]);
  }

  asString(value: unknown): string {
    return String(value ?? '');
  }

  asArray(value: unknown): any[] {
    return Array.isArray(value) ? value : [];
  }
  isSimpleArray(value: any): boolean {
    return Array.isArray(value) && value.length > 0 && !this.isObject(value[0]);
  }
  scrollToColumn(event: any) {
    const text = event.target.value.trim().toLowerCase();
    if (!text) return;

    const index = this.tableHeaders.findIndex(h =>
      this.formatHeader(h).toLowerCase().includes(text)
    );

    if (index !== -1) {
      const column = document.getElementById('col-' + index);
      if (column) {
        column.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });

        // highlight effect
        column.style.background = '#cfe2ff';
        setTimeout(() => (column.style.background = ''), 2000);
      }
    }
  }

  goBack(): void {
    this.router.navigate(['/vp-onboardingForm']);
  }

}